/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { RfqHeadingListItemDto } from '@gh/builder-shared-data';
import { whenExisting, whenRemoved } from '@gh/common-shared';
import { DirtyType } from '@gh/common-shared-data';

export type RfqHeadingListItem = RfqHeadingListItemDto;

export function updateHeadingItemsToSave(items: RfqHeadingListItem[]): RfqHeadingListItem[] {
  const remains = <RfqHeadingListItem[]>items.filter(whenExisting).map((item, index) => ({
    ...item,
    sortOrder: index,
    dirtyType: item.dirtyType || DirtyType.Updated,
  }));
  const removed = <RfqHeadingListItem[]>items.filter(whenRemoved);

  return remains.concat(removed);
}
